import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap"
import secureLocalStorage from "react-secure-storage"
import avatar from "../../assets/images/users/avatar-1.jpg"
import { FetchPutData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Configs from "../../config"

const UserProfile = ({ open, onClose }) => {
  const Admin = secureLocalStorage?.getItem("admin_user") || {}

  // State
  const [photo, setPhoto] = useState("")
  const [file, setFile] = useState(null)

  const [loading, setLoading] = useState(false)
  const [name, setName] = useState(Admin.name || "")
  const [email, setEmail] = useState(Admin.email || "")
  const [currentPassword, setCurrentPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [errors, setErrors] = useState({})

  // Avatar upload
  const handlePhotoChange = e => {
    const file = e.target.files[0]
    if (file) {
      setFile(file)
      const reader = new FileReader()
      reader.onload = ev => setPhoto(ev.target.result)
      reader.readAsDataURL(file)
    }
  }

  // Validation
  const validate = () => {
    const tempErrors = {}
    if (!name) tempErrors.name = "Name is required"
    if (!email) tempErrors.email = "Email is required"
    const isPasswordEntered = currentPassword || newPassword || confirmPassword

    if (isPasswordEntered) {
      if (!currentPassword)
        tempErrors.currentPassword = "Current password is required"
      if (!newPassword) tempErrors.newPassword = "New password is required"
      else if (newPassword.length < 6)
        tempErrors.newPassword = "Password must be at least 6 characters"
      if (!confirmPassword)
        tempErrors.confirmPassword = "Confirm password is required"
      else if (newPassword !== confirmPassword)
        tempErrors.confirmPassword = "Passwords do not match"
    }
    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  const handleSave = async () => {
    if (!validate()) return
    const APIdata = await FetchPutData(setLoading, "staff", Admin?.id || Admin?._id, {
      email,
      password: currentPassword,
      newPassword,
      name,
      profilePicture: file,
    })
    if (APIdata.data.success) {
      Swal.fire({
        title: "Admin Profile Updated Successfully",
        icon: "success",
      })
      secureLocalStorage.setItem("admin_user", APIdata?.data?.staff)
      onClose()
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: APIdata.res?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <Modal isOpen={open} toggle={onClose} centered size="lg">
      <ModalHeader toggle={onClose}>Admin Profile</ModalHeader>
      <ModalBody className="pb-0">
        {/* Editable Fields */}
        <Card className="mb-0">
          <CardBody>
            <Row>
              <Col md={6}>
                <Row className="me-3 align-items-center">
                  <Col md={9}>
                    <div className="mb-3">
                      <Label>Upload Profile Image</Label>
                      <Input
                        type="file"
                        accept="image/*"
                        onChange={handlePhotoChange}
                        className="mt-2"
                      />
                    </div>
                  </Col>
                  <Col md={3} className="px-0">
                    <img
                      src={photo ? photo : Admin?.profilePicture ? `${Configs.imageurl}${Admin?.profilePicture}` : avatar}
                      alt="avatar"
                      className="rounded-circle img-thumbnail"
                      style={{ width: 80, height: 80 }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Label>Password</Label>
                  <Input
                    type={showPassword ? "text" : "password"}
                    value={currentPassword}
                    onChange={e => setCurrentPassword(e.target.value)}
                    invalid={!!errors.currentPassword}
                  />
                  {errors.currentPassword && (
                    <div className="text-danger mt-1">
                      {errors.currentPassword}
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            {/* Password & New Password */}
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <Label>Name</Label>
                  <Input
                    value={name}
                    onChange={e => setName(e.target.value)}
                    invalid={!!errors.name}
                  />
                  {errors.name && (
                    <div className="text-danger mt-1">{errors.name}</div>
                  )}
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Label>New Password</Label>
                  <Input
                    type={showPassword ? "text" : "password"}
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                    invalid={!!errors.newPassword}
                  />
                  {errors.newPassword && (
                    <div className="text-danger mt-1">{errors.newPassword}</div>
                  )}
                </div>
              </Col>
            </Row>

            {/* Confirm Password & Show Password */}
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <Label>Email</Label>
                  <Input
                    type="email"
                    value={email}
                    disabled
                    onChange={e => setEmail(e.target.value)}
                    invalid={!!errors.email}
                  />
                  {errors.email && (
                    <div className="text-danger mt-1">{errors.email}</div>
                  )}
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-2">
                  <Label>Confirm Password</Label>
                  <Input
                    type={showPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    invalid={!!errors.confirmPassword}
                  />
                  {errors.confirmPassword && (
                    <div className="text-danger mt-1">
                      {errors.confirmPassword}
                    </div>
                  )}
                </div>
                <div className="form-check">
                  <Input
                    type="checkbox"
                    id="showPassword"
                    checked={showPassword}
                    onChange={() => setShowPassword(!showPassword)}
                  />
                  <Label check htmlFor="showPassword">
                    Show Password
                  </Label>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </ModalBody>

      <ModalFooter>
        <Button color="primary" onClick={handleSave}>
          Save Changes
        </Button>
        <Button color="secondary" onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default UserProfile
